import { render, staticRenderFns } from "./AbroadZhanhuiDetails.vue?vue&type=template&id=40ba1c3a&scoped=true"
import script from "./AbroadZhanhuiDetails.vue?vue&type=script&lang=js"
export * from "./AbroadZhanhuiDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ba1c3a",
  null
  
)

export default component.exports